module.exports = __webpack_public_path__ + "img/caroline-girvan.2ef3ee2e.jpg";